import SignInForm from '../forms/SignIn';
import AuthLayout from '../Assets/AuthLayout';

const SignInPage = () => {

  return (
    <AuthLayout>
      <div className="w-full max-w-sm">
        <SignInForm />
      </div>
    </AuthLayout>
  );
};

export default SignInPage;